<template>
  <div class="payment-selector">
    <h2 class="payment-selector__popup-title">
      Choose payment method
    </h2>
    <div
      class="payment-selector__list">
      <div
        v-for="method in paymentMethods"
        :key="method.id"
        class="payment-selector__item-wrapper"
        :class="{
          'payment-selector__item--active': method.id === selectedMethodId,
          'payment-selector__item--paypal': !isPayPalAvailable && method.id === PaymentSystemModel.METHODS.PAYPAL.id,
          'payment-selector__item--blocked': method.id === PaymentSystemModel.METHODS.PAYPAL.id && !isPayPalAvailable
        }"
        @click="selectMethod(method.id)">
        <div class="payment-selector__item">
          <!--          <img-->
          <!--            v-if="method.id === PaymentSystemModel.METHODS.PAYPAL.id && !isCod"-->
          <!--            :src="isPayPalAvailable ? '/images/icons/unlock.svg' : '/images/icons/lock.svg'"-->
          <!--            height="20"-->
          <!--            width="15"-->
          <!--            alt=""-->
          <!--            class="payment-selector__lock">-->
          <img
            v-if="method.id === PaymentSystemModel.METHODS.PAYPAL.id"
            :src="isPayPalAvailable ? '/images/icons/unlock.svg' : '/images/icons/lock.svg'"
            height="20"
            width="15"
            alt=""
            class="payment-selector__lock">

          <div
            class="payment-selector__radio shape-dot"
            :class="{ 'shape-dot--active': method.id === selectedMethodId }" />

          <img
            v-if="method.picTitle"
            :src="`/images/payment_systems/white/${method.picTitle}`"
            alt=""
            class="payment-selector__pic">

          <img
            v-else
            :src="`/images/payment_systems/white/${method.pic}`"
            alt=""
            class="payment-selector__pic">

          <div class="payment-selector__title transition--color">
            <template v-if="!isPayPalAvailable && method.id === PaymentSystemModel.METHODS.PAYPAL.id">
              <!--  &lt;!&ndash; {{ initialSelfplayState || isCoaching || isCod ?
              method.title : method.selectorCaption }}&ndash;&gt;-->
              {{ method.selectorCaption }}
            </template>
            <template v-else>
              {{ method.title || method.selectorCaption }}
            </template>
          </div>

          <span
            v-if="methodBadgeMap(method)"
            class="payment-selector__label"
            v-html="methodBadgeMap(method)" />

          <div
            v-if="method.subtitle"
            class="payment-selector__subtitle transition--color">
            {{ method.subtitle }}
          </div>

          <div
            v-if="isFirstPaymentPromo(method.id)"
            class="payment-selector__special">
            Don't miss out! Discount for 2 hours only!
          </div>
        </div>
      </div>
    </div>

    <div class="payment-selector__footer">
      <!--      <div-->
      <!--        v-if="selfplayOption && isPaymentAvailable && !initialSelfPlay"-->
      <!--        :class="{'payment-selector__selfplay-wrapper&#45;&#45;checked': selfplayOption.isChecked }"-->
      <!--        class="payment-selector__selfplay-wrapper">-->
      <!--        <div class="payment-selector__selfplay-header">-->
      <!--          <img-->
      <!--            src="/images/icons/lock.svg"-->
      <!--            height="20"-->
      <!--            width="15"-->
      <!--            class="payment-selector__selfplay-lock"-->
      <!--            alt="">-->
      <!--          <span class="payment-selector__selfplay-lock-text">-->
      <!--            PayPal-->
      <!--          </span>-->
      <!--          <img-->
      <!--            src="/images/payment_systems/white/pay-pal.svg"-->
      <!--            alt=""-->
      <!--            width="64"-->
      <!--            height="24"-->
      <!--            class="payment-selector__selfplay-icon">-->
      <!--        </div>-->
      <!--        <p class="payment-selector__selfplay-text">-->
      <!--          Available only for self-play options-->
      <!--        </p>-->
      <!--        <label class="payment-selector__selfplay">-->
      <!--          <ui-checkbox-->
      <!--            v-model="selfplayOption.isChecked"-->
      <!--            @input="selectMethod(ABTestPaypalPaymentSystem.userGroup.groupId === 1 ?-->
      <!--              PaymentSystemModel.METHODS.EPOCH.id : PaymentSystemModel.METHODS.PAYPAL.id)">-->
      <!--            <template v-if="selfplayOption.isChecked">-->
      <!--              Self-play option added-->
      <!--            </template>-->
      <!--            <template v-else>-->
      <!--              Add Self-play option-->
      <!--            </template>-->
      <!--          </ui-checkbox>-->
      <!--          <span-->
      <!--            v-if="selfplayOptionPrice"-->
      <!--            class="payment-selector__selfplay-price">-->
      <!--            {{ selfplayOptionPrice }}-->
      <!--          </span>-->
      <!--        </label>-->

      <!--        <base-tooltip-->
      <!--          token="whats-next-213"-->
      <!--          :triggers="['click']"-->
      <!--          z-index="2147483011"-->
      <!--          class="payment-selector__selfplay-info">-->
      <!--          <template #default>-->
      <!--            <span class="button button-dark payment-selector__selfplay-info">-->
      <!--              Learn more-->
      <!--            </span>-->
      <!--          </template>-->
      <!--          <template #content>-->
      <!--            Payments with PayPal are only available if you choose a Self-Play option.-->
      <!--            Self-Play means that you're willing to participate in this activity by yourself.-->
      <!--            SkyCoach pros will join you in-game, and as a team, you're going-->
      <!--            to start an activity you ordered.-->
      <!--          </template>-->
      <!--        </base-tooltip>-->
      <!--      </div>-->
      <div class="payment-selector__controls">
        <ui-input
          v-if="[
            PaymentSystemModel.CARDPAY_2_WEBMONEY.id,
            PaymentSystemModel.CARDPAY_2_QIWI.id,
          ].includes(selectedMethodId)"
          v-model="eWallet"
          title="Wallet number"
          class="payment-selector__input"
          :error="eWalletError"
          @input="eWalletError = ''" />

        <div
          class="button button-main payment-selector__button"
          @click="emitValue">
          Buy for {{ currencyValue(data.component.price.newPrice) }}
        </div>
      </div>

      <div class="payment-selector__secure">
        <img
          src="/images/payment_systems/payment-secure.svg"
          width="79"
          height="22"
          alt="secure">
        <span>We protect your privacy with advanced encryption</span>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentSystemModel from 'Models/PaymentSystemModel';
import CurrencyOfferModel from 'Models/CurrencyOfferModel';
import { mapState, mapGetters } from 'vuex';
import { regExpWMZ } from 'Root/helpers/regexps';
import UiInput from 'Components/ui/Input/UiInput.vue';
// import BaseTooltip from 'Components/ui/Tooltip/BaseTooltip.vue';
import { canSupportApplePay } from 'Root/helpers/tools';
// import UiCheckbox from 'Components/ui/Checkbox/UiCheckbox.vue';
import GameModel from 'Models/GameModel';
import googleTagAnalytics from 'Root/drivers/googleTagAnalytics';
import getBlue from 'Root/drivers/getBlue';
import {
  ABTestPaypalPaymentSystem,
  ABTestCheckoutPaymentSystem,
  ABTestEpochPaymentSystem,
} from 'Root/drivers/ABTestsDriver';
import fingerprintHeader from 'Root/mixins/fingerprintHeader';
import RegionModel from 'Models/RegionModel';
import PaypalCardPayment from 'Components/PaymentPopups/PaypalCardPayment.vue';

export default {
  name: 'PaymentMethodSelector',

  components: {
    // BaseTooltip,
    UiInput,
    // UiCheckbox,
  },

  mixins: [fingerprintHeader],

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedMethodId: null,
      initialSelfplayState: false,
      initialMethodId: null,
      PaymentSystemModel,
      eWallet: null,
      eWalletError: null,
      ABTestPaypalPaymentSystem,
      initialSelfPlay: false,
      initialOptions: {},
      paypalCardOpened: false,
    };
  },

  computed: {
    ...mapState(['userDevice', 'activeRegion', 'user', 'countryCode', 'activeGame']),
    ...mapGetters(['currencyValue']),

    isAccountPurchase() {
      return this.data?.offerData?.marketplace_type === CurrencyOfferModel.TYPES.ACCOUNT;
    },

    isPaymentAvailable() {
      return !this.isDestiny
      && this.data?.offerData?.marketplace_type !== CurrencyOfferModel.TYPES.ACCOUNT
      && this.data?.offerData?.marketplace_type !== CurrencyOfferModel.TYPES.GOLD
      && !this.data?.component?.isGoldProduct;
    },

    isEpochAvailable() {
      return false;
    },

    paymentMethods() {
      // Изначально получаем список доступных методов оплаты
      let enabledMethods = PaymentSystemModel.METHODS_LIST
      // todo @task SKY-1764 @task SKY-1621 это временно для тестов на проде
        .filter((m) => (m.onlyForUsersWithId ? m.onlyForUsersWithId.includes(this.user?.id) : true))
        .filter((m) => m.enabled && m.regions.includes(this.activeRegion.id))
        .filter((m) => !m.regionsCode || m.regionsCode.includes(this.countryCode));

      // SKY-5549 Костыль для замены PayPal на Epoch (only for products that has is_currency_offer_finance_report or marketplace)
      const epochMethod = enabledMethods.find((method) => method.id === PaymentSystemModel.METHODS.EPOCH.id);
      if (epochMethod) {
        enabledMethods = enabledMethods.filter((method) => method.id !== PaymentSystemModel.METHODS.EPOCH.id);

        if (ABTestEpochPaymentSystem.userGroup.groupId === 2
                && this.isPayPalAvailable) {
          enabledMethods = enabledMethods.map((method) => {
            if (method.id === PaymentSystemModel.METHODS.PAYPAL.id) {
              return {
                ...PaymentSystemModel.METHODS.EPOCH,
              };
            }

            return method;
          });
        }
      }

      // SKY-5030 Если регион Европа, то всегда Ecommpay на первом месте без подписей, а не Stripe
      if (ABTestCheckoutPaymentSystem.isActive && this.activeRegion.id === RegionModel.EU.id) {
        enabledMethods = enabledMethods.filter((m) => m.id !== PaymentSystemModel.STRIPE.id
                && m.id !== PaymentSystemModel.ECOMMPAY.id
                && m.id !== PaymentSystemModel.CHECKOUT.id);

        if (ABTestCheckoutPaymentSystem.userGroup.groupId === 1
          || ABTestCheckoutPaymentSystem.userGroup.groupId === 2) {
          const ecommpayNoName = {
            id: PaymentSystemModel.ECOMMPAY.id,
            pic: 'visa-and-mastercard.svg',
            title: 'Visa or Mastercard',
            enabled: true,
            mulModifier: PaymentSystemModel.METHODS.ECOMMPAY.mulModifier,
            baseCommission: PaymentSystemModel.METHODS.ECOMMPAY.baseCommission,
            regions: [
              RegionModel.EU.id,
              RegionModel.USA.id,
            ],
          };

          enabledMethods.splice(1, 0, ecommpayNoName);
        } else {
          // User is in Checkout group for EU
          let paymentSystemResult;
          if (this.isAccountPurchase) {
            // Reroute Account purchase in Checkout group to Ecommpay for EU
            paymentSystemResult = {
              id: PaymentSystemModel.ECOMMPAY.id,
              pic: 'visa-and-mastercard.svg',
              title: 'Visa or Mastercard',
              enabled: true,
              mulModifier: PaymentSystemModel.METHODS.ECOMMPAY.mulModifier,
              baseCommission: PaymentSystemModel.METHODS.ECOMMPAY.baseCommission,
              regions: [
                RegionModel.EU.id,
                RegionModel.USA.id,
              ],
            };
          } else {
            // Regular Checkout for non-account purchases in EU
            paymentSystemResult = {
              id: PaymentSystemModel.CHECKOUT.id,
              pic: 'visa-and-mastercard.svg',
              title: 'Visa or Mastercard',
              enabled: true,
              mulModifier: PaymentSystemModel.METHODS.CHECKOUT.mulModifier,
              baseCommission: PaymentSystemModel.METHODS.CHECKOUT.baseCommission,
              regions: [
                RegionModel.EU.id,
                RegionModel.USA.id,
              ],
            };
          }
          enabledMethods.splice(1, 0, paymentSystemResult);
        }
      }

      // SKY-5030 A/B тест на US юзеров активен, подставляем платежку в зависимости от процентов
      if (ABTestCheckoutPaymentSystem.isActive && this.activeRegion.id !== RegionModel.EU.id) {
        const cardPaymentIndex = enabledMethods.findIndex((m) => m.id === PaymentSystemModel.STRIPE.id
                || m.id === PaymentSystemModel.ECOMMPAY.id || m.id === PaymentSystemModel.PAYPAL_CARD.id
                || m.id === PaymentSystemModel.CHECKOUT.id);

        enabledMethods = enabledMethods.filter((m) => m.id !== PaymentSystemModel.STRIPE.id
                && m.id !== PaymentSystemModel.ECOMMPAY.id && m.id !== PaymentSystemModel.PAYPAL_CARD.id
                && m.id !== PaymentSystemModel.CHECKOUT.id);
        let paymentSystemResult;
        if (ABTestCheckoutPaymentSystem.userGroup.groupId === 3) {
          if (this.selfplayOption?.isChecked && this.isPaymentAvailable) {
            paymentSystemResult = PaymentSystemModel.METHODS.PAYPAL_CARD;
          } else {
            paymentSystemResult = PaymentSystemModel.METHODS.CARD;
          }
        } else if (ABTestCheckoutPaymentSystem.userGroup.groupId === 1) {
          paymentSystemResult = PaymentSystemModel.METHODS.CARD;
        } else if (ABTestCheckoutPaymentSystem.userGroup.groupId === 2) {
          paymentSystemResult = PaymentSystemModel.METHODS.ECOMMPAY;
        } else if (ABTestCheckoutPaymentSystem.userGroup.groupId === 4) {
          // User is in Checkout group for US
          if (this.isAccountPurchase) {
            // Reroute Account purchase in Checkout group to Stripe for US
            paymentSystemResult = PaymentSystemModel.METHODS.CARD; // Stripe is METHOD.CARD
          } else {
            // Regular Checkout for non-account purchases in US
            paymentSystemResult = PaymentSystemModel.METHODS.CHECKOUT;
          }
        }

        paymentSystemResult = {
          ...paymentSystemResult,
          pic: 'visa-and-mastercard.svg',
          title: 'Visa or Mastercard',
          subtitle: '',
        };

        if (cardPaymentIndex === -1) {
          enabledMethods.unshift(paymentSystemResult);
        } else {
          enabledMethods.splice(cardPaymentIndex, 0, paymentSystemResult);
        }
      }

      // SKY-5039: Route specific countries to Stripe instead of Ecommpay
      if (this.activeRegion.id === RegionModel.EU.id
          && (PaymentSystemModel.COUNTRY_PAYMENT_ROUTING.STRIPE_PREFERRED_COUNTRIES.includes(this.countryCode)
           || PaymentSystemModel.COUNTRY_PAYMENT_ROUTING.STRIPE_PREFERRED_COUNTRIES.includes(this?.user?.country))) {
        enabledMethods = enabledMethods.filter((m) => m.id !== PaymentSystemModel.ECOMMPAY.id);
        if (!enabledMethods.some((m) => m.id === PaymentSystemModel.STRIPE.id)) {
          const stripeNoName = {
            id: PaymentSystemModel.STRIPE.id,
            pic: 'visa-and-mastercard.svg',
            title: 'Visa or Mastercard',
            enabled: true,
            mulModifier: PaymentSystemModel.METHODS.CARD.mulModifier,
            firstPurchaseMulModifier: PaymentSystemModel.METHODS.CARD.firstPurchaseMulModifier,
            baseCommission: PaymentSystemModel.METHODS.CARD.baseCommission,
            regions: [
              RegionModel.EU.id,
              RegionModel.USA.id,
            ],
          };

          enabledMethods.splice(1, 0, stripeNoName);
        }
      }

      // Filter out Checkout explicitly if it wasn't handled by A/B test rerouting above for account purchases
      if (this.isAccountPurchase) {
        enabledMethods = enabledMethods.filter((m) => m.id !== PaymentSystemModel.CHECKOUT.id);
      }

      // SKY-5316 disable ecommpay commission for the USA on first purchase
      enabledMethods.forEach((m) => {
        if (m.id === PaymentSystemModel.ECOMMPAY.id && this.activeRegion.id === RegionModel.USA.id) {
          m.firstPurchaseMulModifier = 0;
        }
      });

      if (canSupportApplePay()) {
        enabledMethods.splice(2, 0, PaymentSystemModel.METHODS.APPLE_PAY); // todo @task SKY-2269 Добавить Apple pay
      }

      enabledMethods = enabledMethods
        .filter((m) => {
          if (typeof m?.minValue !== 'undefined' && this.data.component.price.newPrice <= m.minValue) {
            return false;
          }

          return !(typeof m?.maxValue !== 'undefined' && this.data.component.price.newPrice >= m.maxValue);
        });

      if (!this.isMobile) {
        return enabledMethods.filter((m) => !m.mobileOnly);
      }

      return enabledMethods;
    },

    isMobile() {
      return this.userDevice.innerWidth <= 600;
    },

    selfplayOption() {
      return this.data.component?.selfplayOption;
    },

    isCoaching() {
      return this.data.component.isCoaching;
    },

    isCod() {
      return this.$store.state.activeGame.id === GameModel.COD_MW.id;
    },

    isDestiny() {
      return this.$store.state.activeGame.id === GameModel.DESTINY.id;
    },

    isPayPalAvailable() {
      return this.selfplayOption?.isChecked && this.isPaymentAvailable;
    },

    selfplayOptionPrice() {
      return this.selfplayOption ? this.selfplayOption.displayPrice : null;
    },

    paypalMethod() {
      return this.paymentMethods.find((method) => method.id === PaymentSystemModel.METHODS.PAYPAL.id);
    },

    epochMethod() {
      return this.paymentMethods.find((method) => method.id === PaymentSystemModel.METHODS.EPOCH.id);
    },
  },

  watch: {
    selectedMethodId(id) {
      // eslint-disable-next-line vue/no-mutating-props
      this.data.component.selectedPaymentMethod = id;
    },

    paymentMethods() {
      if (this.initialMethodId === PaymentSystemModel.METHODS.EPOCH.id && !this.epochMethod && this.paypalMethod) {
        this.initialMethodId = PaymentSystemModel.METHODS.PAYPAL.id;
        this.selectedMethodId = this.initialMethodId;
      }
    },
  },

  beforeMount() {
    // this.initialSelfplayState = this.selfplayOption?.isChecked || this.data.component.product.meta?.isPayPalAvailable;
    // if (this.isCoaching || this.initialSelfplayState) {
    //   this.initialMethodId = PaymentSystemModel.METHODS.PAYPAL.id;
    // } else {
    //   this.initialMethodId = this.paymentMethods.find((m) => m.id !== PaymentSystemModel.METHODS.PAYPAL.id)?.id;
    // }

    this.initialSelfPlay = this.selfplayOption?.isChecked;
    this.initialMethodId = this.paymentMethods.find((m) => (this.selfplayOption?.isChecked && (this.isEpochAvailable
            || this.isPaymentAvailable))
            || (m.id !== PaymentSystemModel.METHODS.PAYPAL.id && m.id !== PaymentSystemModel.METHODS.EPOCH.id))?.id;
    this.selectedMethodId = this.initialMethodId;
    this.initialOptions = JSON.parse(JSON.stringify(this.data.component.allProductOptions) || '{}');
  },

  methods: {
    selectMethod(methodId) {
      if (this.selectedMethodId === methodId) {
        return;
      }
      if (methodId === PaymentSystemModel.METHODS.PAYPAL.id && !this.isPayPalAvailable) {
        if (this.selectedMethodId === methodId) {
          this.selectedMethodId = this.initialMethodId;
        }
        return;
      }

      this.selectedMethodId = methodId;
    },

    sendGoogleAnalytics() {
      if (this.data.component?.isTips) {
        return;
      }

      googleTagAnalytics.emitBuyForNew(PaymentSystemModel.ID_TO_DATA[this.selectedMethodId].title);
      googleTagAnalytics.fireBuyClick('buy_for_x_3', this.data.component.product.title);
      getBlue.fireCartVisit(this.data.component.product.id);
    },

    emitValue() {
      // todo restore
      if (this.selectedMethodId === PaymentSystemModel.METHODS.PAYPAL_CARD.id) {
        this.openPaypalCard();
        return;
      }

      let methodId = this.selectedMethodId;

      if (methodId === PaymentSystemModel.CARDPAY_2_WEBMONEY.id) {
        if (!this.eWallet) {
          this.eWalletError = 'Webmoney wallet number is required.';
          return;
        }

        if (!regExpWMZ.test(this.eWallet)) {
          this.eWalletError = 'Incorrect Webmoney wallet number.';
          return;
        }
      }

      if (methodId === PaymentSystemModel.METHODS.QIWI.id) {
        if (!this.eWallet) {
          this.eWalletError = 'QIWI wallet number is required.';
          return;
        }
      }

      // todo @task SKY-2269 Добавить Apple pay, но сохранить поведение оплаты как при Visa
      if (methodId === PaymentSystemModel.METHODS.APPLE_PAY.id) {
        methodId = PaymentSystemModel.METHODS.CARD.id;
        googleTagAnalytics.fireGtagEvent('apple_pay', 'payment_type', 'apple pay click');
      }

      this.$vuedals.close({
        methodId,
        wmNumber: this.eWallet,
      });

      this.sendGoogleAnalytics();
    },

    methodBadgeMap(method) {
      if (this.data.component.isTips) {
        return null;
      }

      const isFirstPurchase = !(this.user?.customer_counters?.paid_orders_count > 0);
      const { mulModifier, baseCommission, firstPurchaseMulModifier: originalFirstPurchaseMulModifier } = method;

      let firstPurchaseMulModifier = originalFirstPurchaseMulModifier;

      // SKY-5316 disable ecommpay commission for the USA on first purchase
      if (method.id === PaymentSystemModel.ECOMMPAY.id
          && this.activeRegion.id === RegionModel.USA.id
          && isFirstPurchase
      ) {
        firstPurchaseMulModifier = 0;
      }

      if (isFirstPurchase && typeof firstPurchaseMulModifier !== 'undefined') {
        if (baseCommission) {
          return `<em>+ ${mulModifier}%</em> + ${this.currencyValue(baseCommission)}`;
        }

        return firstPurchaseMulModifier && `+ ${firstPurchaseMulModifier}%`;
      }

      if (mulModifier) {
        if (baseCommission) {
          return `+ ${mulModifier}% + ${this.currencyValue(baseCommission)}`;
        }

        return `+ ${mulModifier}%`;
      }

      return null;
    },

    isCardMethod(methodId) {
      return [...PaymentSystemModel.STRIPE_METHODS_LIST,
        PaymentSystemModel.METHODS.ECOMMPAY.id,
        PaymentSystemModel.METHODS.PAYPAL_CARD.id,
        PaymentSystemModel.METHODS.CHECKOUT.id].includes(methodId);
    },

    isFirstPaymentPromo(methodId) {
      const isFirstPurchase = !(this.user?.customer_counters?.paid_orders_count > 0);

      return isFirstPurchase && this.isCardMethod(methodId);
    },

    openPaypalCard(userEmail) {
      this.userEmail = userEmail;

      this.paypalCardOpened = true;
      this.$vuedals.openMobilePanel({
        name: 'paypal-popup',
        title: 'Pay by card',
        component: PaypalCardPayment,
        closeOnBackdrop: true,
        data: this,
        onDismiss: async () => {
          this.paypalCardOpened = false;

          const orderId = this.$route.query?.order;

          if (orderId) {
            await this.$axios.post(`/api/shop/order/${orderId}/cancel`);
            await this.$router.replace({ query: {} });
          }
        },
      });

      // this.sendGooglePaymentAnalytics();
    },
  },
};
</script>

<style lang="scss" scoped>
// mobile
.payment-selector {
  --scroll-width-px: 6px;
  --scroll-track-color: transparent;
  --scroll-thumb-color: #{rgba($color--basic-light-gray, .25)};

  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  overflow: hidden;
  height: 100%;
}

.payment-selector__popup-title {
  font-weight: 500;
  font-size: $text-17px;
  text-align: center;
}

.payment-selector__list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  overflow: hidden auto;
}

.payment-selector__button {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  font-size: $text-13px;
  font-weight: 500;
  text-transform: unset;
}

.payment-selector__controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.payment-selector__input {
  --height: 48px !important;
  --background-color: #{$color--basic-dark-gray} !important;
  --color: #{$color--basic-light-gray} !important;

  flex-grow: 1;
  width: 100%;
}

.payment-selector__secure {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding: 16px;
  font-size: $text-13px;
  color: $color--basic-dark-gray;
}

.payment-selector__item--paypal {
  order: 1;
}

.payment-selector__item--blocked {
  display: none;

  .payment-selector__radio {
    display: none;
  }

  .payment-selector__lock {
    display: block;
    margin: 0 auto;
  }
}

.payment-selector__footer {
  display: grid;
  grid-template-columns: minmax(1px, 1fr);
  gap: 16px;
  width: 100%;
}

.payment-selector__item {
  position: relative;
  display: grid;
  grid-template-columns: 20px 53px minmax(1px, 1fr) max-content;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 10px;
  background-color: $color--basic-menu;
  color: $color--basic-dark-gray;
  transition: color .15s ease-out;
  cursor: pointer;
}

.payment-selector__item--paypal .payment-selector__item {
  grid-template-columns: 20px 70px 190px 1fr;
}

.payment-selector__title {
  font-size: $text-13px;
  font-weight: 400;
  color: $color--basic-white;
}

.payment-selector__subtitle {
  font-size: 11px;
  font-weight: 400;
  color: $color--basic-dark-gray;
  text-align: center;
  order: 1;
}

.payment-selector__special {
  grid-column: 1 / -1;
  width: 100%;
  font-size: $text-15px;
  font-weight: 400;
  color: $color--basic-white;
  text-align: center;
}

.payment-selector__radio {
  --shape-color: #{$color--basic-dark-gray};
  --inner-size: .5;

  height: 20px;
  width: 20px;
}

.payment-selector__label {
  padding: 4px 8px;
  background-color: $color--basic-dark-gray;
  border-radius: 100px;
  font-weight: 500;
  font-size: $text-15px;
  color: $color--basic-white;

  /deep/ em {
    color: #5F7395;
    text-decoration: line-through;
  }
}

.payment-selector__lock {
  display: none;
}

.payment-selector__lock,
.payment-selector__pic {
  width: auto;
  filter: $filter--white-to-dark-gray;
  transition: filter var(--transition-color-time) var(--transition-color-easing);
}

.payment-selector__selfplay-wrapper {
  position: relative;
  padding: 18px 20px;
  border: 1px solid $color--basic-dark-gray;
  border-radius: 10px;
  transition: padding .2s ease-out, border-color .2s ease-out;
  margin-bottom: 16px;

  &:after {
    content: 'or';
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 20px;
    height: 24px;
    line-height: 24px;
    font-weight: 500;
    font-size: $text-13px;
    color: $color--basic-dark-gray;
    background-color: $color--basic-menu;
    transition: opacity var(--transition-opacity-time) var(--transition-opacity-easing);
  }
}

.payment-selector__selfplay-wrapper.payment-selector__selfplay-wrapper--checked {
  padding: 0;
  border-color: transparent;

  &:after {
    opacity: 0;
  }
}

.payment-selector__selfplay-wrapper--checked {
  .payment-selector__selfplay-header,
  .payment-selector__selfplay-text,
  .payment-selector__selfplay-info {
    display: none;
  }
}

.payment-selector__selfplay-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.payment-selector__selfplay-text,
.payment-selector__selfplay-lock-text {
  color: $color--basic-white;
  font-weight: 500;
  font-size: $text-13px;
}

.payment-selector__selfplay-lock-text {
  line-height: 20px;
  margin-left: 20px;
}

.payment-selector__selfplay-icon {
  margin-left: 100px;
}

.payment-selector__selfplay-text {
  text-align: center;
  margin-bottom: 14px;
}

.payment-selector__selfplay {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.payment-selector__selfplay-price {
  color: $color--basic-dark-gray;
  font-size: $text-13px;
  font-weight: 500;
  margin-left: 4px;
}

.payment-selector__selfplay-info {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 32px;
  text-transform: none;
  border-radius: 100px;
  font-weight: 500;
  font-size: 13px;
  margin: 14px auto 0;
}

.payment-selector__item--active {
  .payment-selector__subtitle,
  .payment-selector__title {
    color: $color--basic-white;
  }

  .payment-selector__item {
    border-color: $color--basic-blue;
    background-color: $color--basic-blue;

    .payment-selector__radio {
      --shape-color: #{$color--basic-white};
    }

    .payment-selector__lock,
    .payment-selector__pic {
      filter: $filter--dark-gray-to-white;
    }
  }
}

@media screen and (max-width: 375px) {
  .payment-selector__lock, .payment-selector__pic {
    height: 18px;
  }
}

@media screen and (max-width: 600px) {
  .payment-selector__subtitle {
    grid-column: 1 / -1;
  }

  .payment-selector__item--paypal .payment-selector__item {
    grid-template-columns: 20px 70px 1fr 1fr;
  }
}

@media screen and (min-width: 601px) {
  .payment-selector {
    width: 100%;
    margin: 0 auto;
  }

  .payment-selector__item--paypal {
    order: unset;

    .payment-selector__item {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      grid-gap: 0;
      padding: 0;
    }

    .payment-selector__pic {
      align-self: center;
      justify-self: center;
      margin-bottom: 14px;
    }

    .payment-selector__title {
      max-width: 200px;
      align-self: center;
    }

    .payment-selector__radio {
      display: none;
    }

    .payment-selector__lock {
      display: block;
      position: absolute;
      top: 12px;
      right: 18px;
    }
  }

  .payment-selector__selfplay-wrapper {
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 1fr max-content 1fr;
    grid-column-gap: 20px;
    grid-template-areas:
        "selfplay-paypal selfplay-text selfplay-info"
        "selfplay-paypal selfplay-checkbox selfplay-info";
    margin-bottom: 38px;

    &:after {
      background-color: $color--basic-black;
    }
  }

  .payment-selector__selfplay-wrapper--checked {
    margin-bottom: 27px;
  }

  .payment-selector__selfplay-header {
    grid-area: selfplay-paypal;
    display: grid;
    margin-bottom: 0;
  }

  .payment-selector__selfplay-lock {
    grid-row: 1 / span 2;
    margin-right: 15px;
  }

  .payment-selector__selfplay-lock-text {
    grid-row: 2;
    margin: 0;
    font-size: $text-15px;
  }

  .payment-selector__selfplay-icon {
    grid-row: 1;
    margin: 0;
  }

  .payment-selector__selfplay-text {
    grid-area: selfplay-text;
    margin-bottom: 15px;
  }

  .payment-selector__selfplay {
    grid-area: selfplay-checkbox;
  }

  .payment-selector__selfplay-info {
    grid-area: selfplay-info;
    margin: auto 0 auto auto;
  }

  .payment-selector__subtitle {
    grid-column: 2;
    grid-row: 2;
    align-self: start;
  }

  .payment-selector__button {
    font-size: $text-15px;
    height: 48px;
    width: max-content;
    justify-self: center;
    padding: 0 16px;
  }
}

@media screen and #{$screen-more-or-640} {
  .payment-selector__popup-title {
    font-size: $text-25px;
  }
}

@media screen and (min-width: 800px) {
  .payment-selector__selfplay-wrapper {
    grid-column-gap: 33px;
    padding: 20px 23px;
  }

  .payment-selector__selfplay-lock {
    margin-right: 28px;
  }
}

@media screen and #{$screen-more-or-1024} {
  .payment-selector {
    width: 524px;
  }
}
</style>
